import React, {useEffect, useState} from 'react';
import Modal from 'react-modal';
import axios from "axios";

const DeleteSurveyImageModel = (props) => {
    const {
        show        = false,
        disabled    = false,
        onCancel    = () => { },
        onComplete  = (file_name) => {},
        file_id     = null,
        file_name   = null,
        job_id      = null,
        survey_id   = null,
        id          = "delete-survey-image",
    } = props;

    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        if (!!submitting) {
            submit();
        }
    }, [submitting]);

    const submit = () => {
        axios.delete(route('web-api.job.survey.image', {
            file:    file_id,
            survey:  survey_id,
            job: job_id,
        }).toString())
            .then((response) => {
                setSubmitting(false);
                onComplete(response);
            })
            .catch((error) => {
                setSubmitting(false);
                onCancel();
            });
    }

    const handleClose = () => {
        onCancel();
    }

    return (
        <Modal
            ariaHideApp={false}
            isOpen={show}
            onRequestClose={() => handleClose()}
            contentLabel="Delete Survey Image"
            className={'ReactModal__Content react-modal-outer modal-dialog admin-modal'}
            style={{
                overlay: {
                    width: '100vw',
                    height: '100vh',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    overflow: 'hidden',
                    outline: 'none',
                },
                content: {
                    width: "100%",
                    height: "100%",
                    padding: 0,
                    border: 0,
                    outline: 'none',
                },
            }}
        >
            <div className="p-4 modal-content" id={id}>
                <div className="modal-header border-0 m-0 p-0 pb-4">
                    <h5 className="modal-title text-eh-navy">Delete Survey Image</h5>
                    <button
                        type="button" className="close"
                        data-dismiss="modal" aria-label="Close"
                        onClick={() => handleClose()}>
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body m-0 mb-3 p-0">
                    <p className="mb-3">
                        Are you sure you want to <b className="text-danger">delete</b> this image:
                    </p>
                    
                    <React.Fragment>
                        <p className="mb-0 text-eh-off-black"><strong>Name</strong></p>
                        <p className="mb-1 text-eh-off-black">{!!file_name? file_name : ""}</p>
                    </React.Fragment>
                    
                </div>
                <div className="modal-footer m-0 p-0 d-flex justify-content-start align-items-center border-0">
                    <button
                        type="submit"
                        className="btn btn-danger py-0 px-3 ml-0 py-0 mr-4"
                        onClick={() => setSubmitting(true)}
                        disabled={submitting || disabled}
                    >
                        {"Yes, Delete Image"}
                    </button>
                    <button
                        type="button" data-dismiss="modal"
                        className="btn btn-outline-eh-off-black px-3 mr-0"
                        onClick={() => handleClose()}
                    >
                        {"Cancel"}
                    </button>
                </div>
            </div>
        </Modal>
    );
}

export default DeleteSurveyImageModel;
